export const listItemPadding = "8px 0 8px 16px";

export const multiColumnTotalSlots = 12;

export const gapBetweenElements = 16;

/** Size in pixels of overflow menu button in list item */
export const overflowButtonSize = 32;
